import { render, staticRenderFns } from "./BusinessValuePage.vue?vue&type=template&id=116d358c&scoped=true"
import script from "./BusinessValuePage.vue?vue&type=script&lang=ts"
export * from "./BusinessValuePage.vue?vue&type=script&lang=ts"
import style0 from "./BusinessValuePage.vue?vue&type=style&index=0&id=116d358c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116d358c",
  null
  
)

export default component.exports